import cn from 'clsx'

export default function ArrowIcon ({ className, toggle, width = 'w-[0.6rem]', height = 'h-[0.375rem]' }) {
  return (
    <svg className={cn(className, width, height, 'transition-transform duration-300 ease-in-out-strong md:h-auto')} style={{ transform: toggle ? 'rotateX(180deg) translateY(-1px)' : 'rotateX(0deg)' }} viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.78761 5.27633C2.96165 3.5915 1.69911 2.51994 0 1.09613L0 0.724609C0.684366 1.08056 1.30973 1.44838 1.87611 1.82806C2.44248 2.18401 2.96165 2.55183 3.43363 2.93151L4 3.41397L4.56637 2.9313C5.03835 2.55162 5.55752 2.18401 6.12389 1.82806C6.69026 1.44838 7.31563 1.08056 8 0.724609V1.09613C6.30089 2.51994 5.03835 3.5915 4.21239 5.27633H3.78761Z" fill="currentColor"/>
    </svg>
  )
}
